import UrlService from './../services/UrlService';

const appPath = UrlService.getApplicationPath();

module.exports = {
    Root: UrlService.getRoot(),
    ClientType: appPath + 'clienttype',
    ClientSearch: appPath + 'clientsearch',
    ClientOin: appPath + 'clientoin',
    ClientResults: appPath + 'clientresults',
    ClientApplication: appPath + 'clientapplication',
    ApplicationForm: appPath + 'applicationform',
    ConfirmDetails: appPath + 'confirmdetails',
    IDVerification: appPath + 'idverification',
    AnnuitiesWelcomePage: appPath + 'annuitieswelcomepage',
    Declaration: appPath + 'declaration',
    ElectronicSubmission: appPath + 'electronicsubmission',
    Congratulations: appPath + 'congratulations',
    NetCodeEntry: appPath + 'netcodeentry',
    NotFound: appPath + 'notfound',
    ApplicationLoading: appPath + 'applicationloading',
    Error: appPath + 'error'
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/RouteConstants.js